import React from 'react';
import { InputOnlyNumber, Btn, Label } from 'components';
import * as S from './style';
import { LABEL_PHONE, PLACEHOLDER_PHONE, BUTTON_SEND_SMS, BUTTON_RESEND_SMS } from 'commons/ZimssaString';

export interface Props {
    value?: string;
    isActive: boolean;
    isSend: boolean;
    onChangeHandler: (type: any, value: string) => void;
    onClickSendSMS: () => void;
}

function PhoneAuth({ value, isActive = false, isSend = false, onChangeHandler, onClickSendSMS, ...props }: Props): React.ReactElement {
    return (
        <S.PhoneAuthContainer>
            <S.LabelWrapper>
                <Label contents={LABEL_PHONE} fontStyle={'caption'} color={'gray_opacity_800'} />
            </S.LabelWrapper>
            <S.AuthWrapper>
                <S.InputNumberWrapper>
                    <InputOnlyNumber inputName={'phone'} placeholder={PLACEHOLDER_PHONE} maxLength={11} onChangeHandler={onChangeHandler} {...props} />
                </S.InputNumberWrapper>
                <S.BtnSendWrapper>
                    <Btn
                        fontStyle={'body2'}
                        backGroundColor={isActive ? 'blue_opacity_100' : 'gray_opacity_200'}
                        color={isActive ? 'blue_900' : 'gray_opacity_400'}
                        children={isSend ? BUTTON_RESEND_SMS : BUTTON_SEND_SMS}
                        onClick={isActive ? onClickSendSMS : () => {}}
                    />
                </S.BtnSendWrapper>
            </S.AuthWrapper>
        </S.PhoneAuthContainer>
    );
}

export default PhoneAuth;
